/**
 * Custom Sound Service
 * API client for custom notification sound operations
 */

import apiClient from './api.client';

export interface CustomSound {
  id: string;
  user_id: string;
  name: string;
  original_filename: string;
  mime_type: string;
  file_size: number;
  created_at: string;
}

/**
 * Get all custom sounds for the current user
 */
export const getCustomSounds = async (): Promise<CustomSound[]> => {
  const response = await apiClient.get('/custom-sounds');
  return response.data.data.sounds;
};

/**
 * Upload a custom notification sound
 */
export const uploadCustomSound = async (file: File, name: string): Promise<CustomSound> => {
  const formData = new FormData();
  formData.append('sound', file);
  formData.append('name', name);

  const response = await apiClient.post('/custom-sounds', formData, {
    headers: {
      'Content-Type': undefined,
    },
  });
  return response.data.data.sound;
};

/**
 * Delete a custom notification sound
 */
export const deleteCustomSound = async (soundId: string): Promise<void> => {
  await apiClient.delete(`/custom-sounds/${soundId}`);
};

/**
 * Get the streaming URL for a custom sound
 * Used by the sound service to fetch audio blobs
 */
export const getCustomSoundAudioUrl = (soundId: string): string => {
  return `/custom-sounds/${soundId}/audio`;
};
